module.exports = __webpack_public_path__ + "static/media/league-manager-bg.4bab24be.jpg";